import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export function BulkPersonalEmailFeatureGate(props: Props) {
    return (
        <FeatureGateModalWrapper
            feature='bulkPersonalEmails'
            isOpen={props.isOpen}
            onClose={() => props.setIsOpen(false)}
            bullets={[
                'Reach up to 500 contacts at once, saving you time on individual outreach.',
                'Use email templates to keep your messaging consistent and professional.',
                'Personalize your messages to build stronger relationships with your audience.',
            ]}
            description='Easily connect with your customers and prospects by sending personalized emails in bulk.'
            title='Send bulk personal emails'
        />
    );
}
